var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import * as React from 'react';
import { includes } from 'lodash';
import { Mutation } from 'react-apollo';
import * as classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { Icon, Input, Button, Dialog, Popover, MenuItem, TextField, IconButton, DialogTitle, ListItemText, ListItemIcon, DialogActions, DialogContent, DialogContentText, } from '@material-ui/core';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Avatar } from '@material-ui/core';
import store from 'src/store';
import Helmet from './Helmet';
import history from 'src/history';
import { mainApi } from 'src/config';
import HelpDialog from './HelpDialog';
import ChannelList from './ChannelList';
import styles from './FullToolbar.style';
import NotificationsBar from './Notifications';
import { getInitials } from 'src/utils/common';
import { toggleSidebar } from 'src/store/actions';
import CreateLinkDialog from './CreateLinkDialog';
import Animate from 'src/theme/components/Animate';
import UserProfileDialog from './UserProfileDialog';
import { compose, isLPUser } from 'src/utils/common';
import { addNotification } from 'src/NotificationWrapper';
import { changeLang } from 'src/translation/store/actions';
import { getTubeData } from 'src/gql/queries/getTube';
import { ErrorDialog } from 'src/components/reusable/ErrorDialog';
import * as authActions from 'src/auth/store/actions/user.actions';
import { getLanguageData, getNotifications } from 'src/auth/cognito/organizationApi';
import { SuccessDialog } from 'src/components/reusable/SuccessDialog';
import { BookMeetingDialog } from '../../reusable/BookMeetingsDialog';
import { updateChannelList } from 'src/store/actions/channel.actions';
import { setLanguageData } from 'src/auth/store/actions/lang.actions';
import UnsupportedDialog from 'src/components/reusable/UnsupportedDialog';
import { getTranslation, getLanguages } from 'src/translation';
import { changeTooltipSettings } from 'src/auth/store/actions/user.actions';
import { listChannelsData } from 'src/gql/queries/listChannels';
import { SupportForm } from 'src/components/routes/channel/users/SupportForm';
import UserInitialConfigurationDialog from './UserInitialConfigurationDialog';
import { userCommandMutation, userCommandVariables } from 'src/gql/userCommand';
import { addCreateLeadMutation, addCreateLeadVariables } from 'src/gql/zendesk';
import { getUserAnalyticsData } from 'src/gql/queries/getUserAnalytics';
import { isNotificationsFeatureEnabled, isUserProfileFeatureEnabled } from 'src/utils/featureFlagChecks';
import BookDemoDialog from 'src/components/reusable/BookDemoDialog';
var MAX_NOTIFICATIONS_TO_SHOW = 10;
// @ts-ignore
var MainToolbar = /** @class */ (function (_super) {
    __extends(MainToolbar, _super);
    function MainToolbar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inFeatureVideoChecked = false;
        _this.state = {
            error: null,
            addMenu: null,
            userMenu: null,
            langMenu: null,
            orgMenu: null,
            helpDialog: false,
            openAddDialog: false,
            selectedAddAction: '',
            showAllLanguages: false,
            createLinkOpen: false,
            showSuccessForm: false,
            notificationsMenu: null,
            unSupportedDialog: false,
            isSupportDialogOpen: false,
            isBookMeetingMenuOpen: false,
            isBookDemoDialogOpen: false,
            isUserProfileDialogOpen: false,
            isTubeDataLoaded: false,
            search: _this.props.searchValue,
            isNewUserConfigurationDialogOpen: false,
        };
        _this.onSupportFormSubmit = function (values, createLeadReq) { return __awaiter(_this, void 0, void 0, function () {
            var orgId, description, data, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!values) return [3 /*break*/, 5];
                        orgId = this.props.orgId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        description = "\n        " + (values.description || 'N/A') + "\n\n\n        URL: " + window.location.href + "\n        ";
                        data = {
                            orgId: orgId,
                            body: description,
                            requesterName: values.firstName + " " + values.lastName,
                            requesterEmail: this.props.userEmail || this.props.email || 'N/A',
                            phoneNumber: values.phoneNumber,
                            subject: values.title,
                        };
                        localStorage.setItem('firstName', values.firstName);
                        localStorage.setItem('lastName', values.lastName);
                        if (!!values.phoneNumber) {
                            localStorage.setItem('phoneNumber', values.phoneNumber);
                        }
                        return [4 /*yield*/, createLeadReq(addCreateLeadVariables({
                                type: 'createTicket',
                                payload: data,
                            }))];
                    case 2:
                        _a.sent();
                        this.setState({
                            showSuccessForm: true,
                            isSupportDialogOpen: false,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.setState({
                            error: e_1.networkError && e_1.networkError.result ? e_1.networkError.result.message : e_1.message,
                            isSupportDialogOpen: false,
                        });
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        this.setState({
                            isSupportDialogOpen: false,
                        });
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        _this.userMenuClick = function (event) {
            _this.setState({ userMenu: event.currentTarget });
        };
        _this.langMenuClick = function (event) {
            _this.setState({ langMenu: event.currentTarget });
        };
        _this.orgMenuClick = function (event) {
            _this.setState({ orgMenu: event.currentTarget });
        };
        _this.orgMenuClose = function (event) {
            _this.setState({ orgMenu: null });
        };
        _this.userMenuClose = function () {
            _this.setState({ userMenu: null });
            setTimeout(function () {
                _this.setState({
                    orgMenu: null,
                    langMenu: null,
                });
            }, 500);
        };
        _this.langMenuClose = function () {
            _this.setState({ langMenu: null });
        };
        _this.notificationClick = function (event) {
            _this.setState({ notificationsMenu: event.currentTarget });
        };
        _this.addMenuClick = function (event) {
            var isIE = navigator.userAgent.indexOf('MSIE ') > -1 || navigator.userAgent.indexOf('Trident/') > -1;
            if (isIE) {
                _this.setState({ unSupportedDialog: true });
            }
            else {
                _this.setState({ addMenu: event.currentTarget });
            }
        };
        _this.onUnsupportedDialogClose = function () { return _this.setState({ unSupportedDialog: false }); };
        _this.addMenuClose = function () {
            _this.setState({ addMenu: null });
        };
        _this.handleCloseAddDialog = function () {
            _this.setState({ openAddDialog: false });
        };
        // private handleOpenHelpDialog = () => {
        //   this.setState({ helpDialog: true })
        // }
        _this.handleCloseHelpDialog = function (tooltip) {
            _this.setState({ helpDialog: false });
            _this.props.changeTooltipSettings(tooltip);
        };
        _this.onSearchChange = function (e) { return _this.setState({ search: e.target.value }); };
        _this.onLangClick = function (lang, skipNotification) { return function () {
            _this.props.changeLang(lang);
            _this.props.savePreferredLanguage(lang);
            getLanguageData(lang).then(function (res) {
                // en-us is used from the local
                if (res.data.lang !== 'en-us') {
                    setLanguageData(res.data.lang, res.data.data)(store.dispatch);
                }
                // Except english and danish all other languages are auto translated
                var isAutoTranslatedLang = !includes(['en-us', 'da'], lang);
                if (!skipNotification) {
                    addNotification({
                        children: (React.createElement("div", { className: "custom-notification" },
                            React.createElement("div", { className: classNames(_this.props.classes.success, 'custom-notification__icon') },
                                React.createElement(Icon, null, "check")),
                            React.createElement("div", { className: "custom-notification__text" },
                                React.createElement("p", { className: "word-break" }, _this.props.translate('lang-changed') + " " + _this.props.translate(lang) + ". " + (isAutoTranslatedLang ? _this.props.translate('lang-changed-auto') : ''))))),
                        position: 'tr',
                        autoDismiss: 5,
                        level: 'success',
                    });
                }
                // fetch new notifications languages
                getNotifications();
            });
            _this.setState({
                addMenu: null,
                langMenu: null,
                userMenu: null,
            });
        }; };
        // @ts-ignore
        _this.onRecord = function () { return (window.location = 'tt-desktop://record'); };
        // @ts-ignore
        _this.onRecordVideo = function () { return (window.location = 'trainingtube-recorder://'); };
        _this.onSearchPress = function (e) {
            if (e.key && e.key !== 'Enter')
                return;
            history.push("/results?search_query=" + _this.state.search.split(' ').join('+'));
        };
        _this.toggleSidebar = function (event) {
            _this.props.toggleSidebar(!_this.props.sidebarStatus);
        };
        _this.onSelectAddAction = function (type) { return function () { return _this.setState({ selectedAddAction: type }); }; };
        _this.onUnselectAddAction = function () { return _this.setState({ selectedAddAction: '' }); };
        return _this;
    }
    MainToolbar.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.searchValue !== nextProps.searchValue) {
            this.setState({ search: nextProps.searchValue });
        }
    };
    MainToolbar.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, user = _a.user, email = _a.email, orgId = _a.orgId, logout = _a.logout, routes = _a.routes, profile = _a.profile, isLPUser = _a.isLPUser, language = _a.language, translate = _a.translate, tubeColor = _a.tubeColor, isDevStage = _a.isDevStage, getTubeQuery = _a.getTubeQuery, showUserEmail = _a.showUserEmail, notifications = _a.notifications, originalOrgId = _a.originalOrgId, switchedOrgId = _a.switchedOrgId, isViewOnlyMode = _a.isViewOnlyMode, isChannelLoaded = _a.isChannelLoaded, listChannelsQuery = _a.listChannelsQuery, organizationLanguages = _a.organizationLanguages, getUserAnalyticsQuery = _a.getUserAnalyticsQuery, isUserProfileFeatureEnabled = _a.isUserProfileFeatureEnabled, externalOrgsUserHasAccessTo = _a.externalOrgsUserHasAccessTo, isNotificationsFeatureEnabled = _a.isNotificationsFeatureEnabled;
        var _b = this.state, userMenu = _b.userMenu, search = _b.search, addMenu = _b.addMenu, langMenu = _b.langMenu, orgMenu = _b.orgMenu, helpDialog = _b.helpDialog, selectedAddAction = _b.selectedAddAction, notificationsMenu = _b.notificationsMenu, unSupportedDialog = _b.unSupportedDialog, createLinkOpen = _b.createLinkOpen, showAllLanguages = _b.showAllLanguages, isNewUserConfigurationDialogOpen = _b.isNewUserConfigurationDialogOpen, isUserProfileDialogOpen = _b.isUserProfileDialogOpen;
        var mainApiUrl = mainApi(isDevStage);
        var languagesToShow = (showAllLanguages || !organizationLanguages.length
            ? getLanguages()
            : organizationLanguages).filter(function (lang) { return lang !== language; });
        var logo = getTubeQuery.loading || getTubeQuery.error
            ? ''
            : getTubeQuery.tube.logo
                ? getTubeQuery.tube.logo
                : '/assets/images/logo.png';
        var isWin = navigator.platform.toLowerCase().indexOf('win') > -1;
        var unseenNotifications = notifications.filter(function (notification) { return !notification.isSeen; });
        if (!isChannelLoaded && !listChannelsQuery.loading) {
            this.props.updateChannelList(listChannelsQuery.channels);
        }
        var userName = (profile.firstName || '') + " " + (profile.lastName || '');
        // Only show the dialog for new users when the tube data is fetched
        // This is done to stop this dialoag from being shown on initial login
        if (!!getTubeQuery.tube &&
            !getTubeQuery.loading &&
            !this.props.isConfigurationCompleted &&
            // This flag is just used to make sure this flag is only loaded once
            !this.state.isTubeDataLoaded &&
            !this.state.isNewUserConfigurationDialogOpen) {
            this.setState({ isNewUserConfigurationDialogOpen: true, isTubeDataLoaded: true });
        }
        return (React.createElement("div", { className: classNames(classes.root, 'flex justify-between flex-row') },
            React.createElement(UnsupportedDialog, { open: unSupportedDialog, url: history.location.pathname, onClose: this.onUnsupportedDialogClose }),
            React.createElement(Helmet, null),
            React.createElement("div", { className: "flex items-center" },
                !isViewOnlyMode && (React.createElement("div", { onClick: this.toggleSidebar, className: classes.hamburgerWrapper },
                    React.createElement(Icon, { className: classes.hamburger }, "menu"))),
                !isViewOnlyMode ? (React.createElement(Link, { id: "home-link", to: "/home" }, Boolean(logo) && React.createElement("img", { className: classes.logo, src: logo, alt: "logo" }))) : (React.createElement("span", null,
                    " ",
                    Boolean(logo) && React.createElement("img", { className: classes.logo, src: logo, alt: "logo" }))),
                React.createElement(Button, { id: "request-demo-button", className: "ml-4 " + classes.demoButton, onClick: function () {
                        _this.setState({
                            isBookDemoDialogOpen: true,
                        });
                    } }, translate('request-demo'))),
            !isViewOnlyMode && (React.createElement("div", { className: classNames('flex items-center w-1/3', classes.centerContainer) },
                listChannelsQuery.channels && (
                // @ts-ignore
                React.createElement(ChannelList, { channels: listChannelsQuery.channels, loading: listChannelsQuery.loading })),
                React.createElement("div", { className: classNames(classes.search, 'flex items-center') },
                    React.createElement(Input, { id: "search", 
                        // @ts-ignore
                        placeholder: translate('search'), className: "pl-16 w-full", disableUnderline: true, value: search, onChange: this.onSearchChange, onKeyPress: this.onSearchPress }),
                    React.createElement(IconButton, { id: "search-btn", className: "w-44 h-44 pr-16", onClick: this.onSearchPress },
                        React.createElement(Icon, null, "search"))))),
            React.createElement("div", { className: "flex items-center" },
                !isViewOnlyMode && (React.createElement(React.Fragment, null,
                    includes(navigator.userAgent, 'tt-desktop') && (React.createElement(IconButton, { id: "video-call-btn", className: "w-64 h-64", onClick: this.onRecord },
                        React.createElement(Icon, null, "video_call"))),
                    React.createElement(Dialog, { open: this.state.openAddDialog, onClose: this.handleCloseAddDialog, "aria-labelledby": "form-dialog-title" },
                        React.createElement(DialogTitle, { id: "form-dialog-title" }, translate('subscribe')),
                        React.createElement(DialogContent, null,
                            React.createElement(DialogContentText, null, translate('subscribeDescription')),
                            React.createElement(TextField, { autoFocus: true, margin: "dense", id: "name", label: translate('email'), type: "email", fullWidth: true })),
                        React.createElement(DialogActions, null,
                            React.createElement(Button, { id: "cancel-btn", name: 'Cancel', onClick: this.handleCloseAddDialog, color: "primary" }, translate('cancel')),
                            React.createElement(Button, { id: "subscribe-btn", name: 'Subscribe', onClick: this.handleCloseAddDialog, color: "primary" }, translate('subscribe')))),
                    React.createElement(Popover, { open: Boolean(addMenu), anchorEl: addMenu, onClose: this.addMenuClose, anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }, transformOrigin: {
                            vertical: 'top',
                            horizontal: 'center',
                        }, classes: {
                            paper: 'py-0',
                        } }, user.role && (React.createElement(React.Fragment, null,
                        !originalOrgId && (React.createElement(MenuItem, __assign({ id: "add-channel-link", name: "Add channel", component: Link }, { to: '/channel/create' }, { onClick: this.addMenuClose, style: selectedAddAction === 'channel' ? { backgroundColor: tubeColor } : {}, onMouseEnter: this.onSelectAddAction('channel'), onMouseLeave: this.onUnselectAddAction, className: classes.listItem }),
                            React.createElement("div", { className: "pl-0", style: { color: selectedAddAction === 'channel' ? 'white' : tubeColor } }, translate('add-channel')))),
                        !originalOrgId && (React.createElement(MenuItem, __assign({ id: "add-track-link", name: "Add track", component: Link }, { to: '/playlist/create' }, { onClick: this.addMenuClose, style: selectedAddAction === 'track' ? { backgroundColor: tubeColor } : {}, onMouseEnter: this.onSelectAddAction('track'), onMouseLeave: this.onUnselectAddAction }),
                            React.createElement("div", { className: "pl-0", style: { color: selectedAddAction === 'track' ? 'white' : tubeColor } }, translate('add-track')))),
                        React.createElement(MenuItem, __assign({ id: "add-video-link", name: "Add video", component: Link }, { to: '/create/video' }, { onClick: this.addMenuClose, style: selectedAddAction === 'video' ? { backgroundColor: tubeColor } : {}, onMouseEnter: this.onSelectAddAction('video'), onMouseLeave: this.onUnselectAddAction }),
                            React.createElement("div", { className: "pl-0", style: { color: selectedAddAction === 'video' ? 'white' : tubeColor } }, translate('add-video-page'))),
                        isWin && (React.createElement(MenuItem, { id: "add-video-link", name: "Record video", onClick: this.onRecordVideo, style: selectedAddAction === 'record-video' ? { backgroundColor: tubeColor } : {}, onMouseEnter: this.onSelectAddAction('record-video'), onMouseLeave: this.onUnselectAddAction },
                            React.createElement("div", { className: "pl-0", style: { color: selectedAddAction === 'record-video' ? 'white' : tubeColor } }, translate('record-video-text'))))))),
                    React.createElement(Button, { id: "get-help-button", className: "ml-4 " + classes.demoButton, onClick: function () {
                            _this.setState({
                                isBookMeetingMenuOpen: true,
                            });
                        } }, translate('get-help')),
                    React.createElement(Button, { className: "w-44 h-64 " + classes.notificationIcon, id: "add-button", onClick: this.addMenuClick },
                        React.createElement("div", { className: "md:flex justify-center items-center" },
                            React.createElement(Icon, { className: "material-icons-outlined", style: { fontSize: 33 } }, "video_call"))),
                    helpDialog && (React.createElement(HelpDialog, { open: helpDialog, isLoadingComplete: !listChannelsQuery.loading && !getTubeQuery.loading, routes: routes, translate: translate, onLangClick: function (lang) {
                            _this.props.changeLang(lang);
                            _this.props.savePreferredLanguage(lang);
                        }, onClose: this.handleCloseHelpDialog, videosWatched: getUserAnalyticsQuery.userAnalytics && getUserAnalyticsQuery.userAnalytics.videosWatched
                            ? getUserAnalyticsQuery.userAnalytics.videosWatched
                            : {} })),
                    this.state.isBookMeetingMenuOpen && (React.createElement(BookMeetingDialog, { open: this.state.isBookMeetingMenuOpen, onClose: function () {
                            _this.setState({
                                isBookMeetingMenuOpen: false,
                            });
                        } })),
                    this.state.isBookDemoDialogOpen && (React.createElement(BookDemoDialog, { open: this.state.isBookDemoDialogOpen, onClose: function () {
                            _this.setState({
                                isBookDemoDialogOpen: false,
                            });
                        } })),
                    isNotificationsFeatureEnabled && (React.createElement(Button, { className: "w-44 h-64 " + classes.notificationIcon, id: "notification-select", onClick: this.notificationClick },
                        React.createElement("div", { className: "md:flex justify-center items-center" },
                            React.createElement(Icon, { style: { fontSize: 33 } }, "notifications"),
                            !!unseenNotifications.length && (React.createElement("div", { className: classes.notificationCountBadge, style: { color: tubeColor } }, unseenNotifications.length))))))),
                isNotificationsFeatureEnabled && !!notificationsMenu && (React.createElement(Popover, { open: !!notificationsMenu, anchorEl: notificationsMenu, onClose: function () {
                        _this.setState({ notificationsMenu: null });
                    }, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center',
                    }, PaperProps: {
                        style: {
                            backgroundColor: 'rgba(255, 255, 255, 0.98)',
                        },
                    } },
                    React.createElement(Mutation, __assign({}, userCommandMutation()), function (userCommandReq) {
                        var notificationsToShow = notifications.slice(0, MAX_NOTIFICATIONS_TO_SHOW);
                        return (React.createElement(NotificationsBar, { tubeColor: tubeColor, translate: translate, notifications: notificationsToShow, updateSeenStatus: function () {
                                return userCommandReq(userCommandVariables({
                                    type: 'updateNotificationIsSeenStatus',
                                    payload: {
                                        isSeen: true,
                                        notificationIds: notificationsToShow
                                            .filter(function (notification) { return !notification.isSeen; })
                                            .map(function (notification) { return notification.id; }),
                                    },
                                }));
                            }, history: _this.props.history, updateIsOpenedStatus: function (notificationId) {
                                return userCommandReq(userCommandVariables({
                                    type: 'updateNotificationIsOpenedStatus',
                                    payload: {
                                        notificationId: notificationId,
                                        isOpened: true,
                                    },
                                }));
                            }, channels: listChannelsQuery.channels }));
                    }))),
                !isViewOnlyMode && (React.createElement(Animate, { delay: 300 },
                    React.createElement(Button, { className: classNames('h-64', classes.userMenu), id: "user-menu-btn", name: "user-menu", onClick: this.userMenuClick },
                        profile.profilePic ? (React.createElement("div", { className: classes.profilePictureDefault, style: { margin: 0 } },
                            React.createElement("img", { src: profile.profilePic }))) : (React.createElement("div", { className: classes.profilePictureDefault },
                            React.createElement("span", { className: classes.profilePicText }, profile.firstName || profile.lastName
                                ? getInitials(userName)
                                : (profile.email || '').slice(0, 2)))),
                        React.createElement(Icon, { className: "text-16 ml-12 hidden sm:flex" }, "keyboard_arrow_down")))),
                React.createElement(Popover, { open: Boolean(userMenu), anchorEl: userMenu, onClose: this.userMenuClose, anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }, transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center',
                    }, classes: {
                        paper: 'py-0',
                    } },
                    !langMenu && !orgMenu && (React.createElement("div", { style: { minWidth: '305px' } },
                        showUserEmail && (React.createElement(React.Fragment, null,
                            React.createElement(MenuItem, { id: "create-link", name: "create-link", className: classes.listItem, onClick: function () {
                                    _this.setState({ createLinkOpen: true });
                                    _this.userMenuClose();
                                } },
                                React.createElement(ListItemText, { className: "pl-0", primary: "" + translate('loggedInAs') + email })))),
                        isWin ? (React.createElement(MenuItem, { id: "download-recorder", name: "download-recorder", className: classes.listItem, onClick: function () {
                                window.location.href = isDevStage
                                    ? 'https://tt-screen-recorder.s3-eu-west-1.amazonaws.com/test-builds/TrainingTube-setup.zip'
                                    : 'https://tt-screen-recorder.s3-eu-west-1.amazonaws.com/TrainingTube-setup-latest.zip';
                                _this.userMenuClose();
                            } },
                            React.createElement(ListItemIcon, null,
                                React.createElement(Icon, null, "download")),
                            React.createElement(ListItemText, { className: classNames('pl-0', classes.toolbarText), children: translate('download-recorder') }))) : null,
                        React.createElement(MenuItem, { id: "switch-language", name: "switch-language", className: classes.listItem, onClick: this.langMenuClick },
                            React.createElement(ListItemIcon, null,
                                React.createElement(Icon, null, "language")),
                            React.createElement(ListItemText, { className: classNames('pl-0', classes.toolbarText), children: translate(language) }),
                            React.createElement(ListItemIcon, null,
                                React.createElement(Icon, null, "chevron_right"))),
                        React.createElement(MenuItem, { id: "switch-organization", name: "switch-organization", className: classes.listItem, onClick: this.orgMenuClick },
                            React.createElement(ListItemIcon, null,
                                React.createElement(Icon, null, "store")),
                            React.createElement(ListItemText, { className: classNames('pl-0', classes.toolbarText), children: translate('switch-ogranization') }),
                            React.createElement(ListItemIcon, null,
                                React.createElement(Icon, null, "chevron_right"))),
                        isLPUser && (React.createElement(MenuItem, { id: "create-link", name: "create-link", className: classes.listItem, onClick: function () {
                                _this.setState({ createLinkOpen: true });
                                _this.userMenuClose();
                            } },
                            React.createElement(ListItemIcon, null,
                                React.createElement(Icon, null, "link")),
                            React.createElement(ListItemText, { className: classNames('pl-0', classes.toolbarText), primary: translate('create-link') }))),
                        isUserProfileFeatureEnabled && !originalOrgId && (React.createElement(MenuItem, { id: "my-profile", name: "my-profile", className: classes.listItem, onClick: function () {
                                _this.setState({ isUserProfileDialogOpen: true });
                                _this.userMenuClose();
                            } },
                            React.createElement(ListItemIcon, null,
                                React.createElement(Icon, null, "person_outline")),
                            React.createElement(ListItemText, { className: classNames('pl-0', classes.toolbarText), primary: translate('my-profile') }))),
                        React.createElement(MenuItem, { id: "logout-link", name: "Logout", className: classes.listItem, onClick: function () {
                                logout();
                                _this.userMenuClose();
                            } },
                            React.createElement(ListItemIcon, null,
                                React.createElement(Icon, null, "exit_to_app")),
                            React.createElement(ListItemText, { className: classNames('pl-0', classes.toolbarText), primary: translate('logout') })))),
                    langMenu && (React.createElement("div", { style: { minWidth: '305px' } },
                        React.createElement(MenuItem, { id: "hide-language", name: "hide-language", className: classes.listItem, onClick: this.langMenuClose },
                            React.createElement(ListItemIcon, null,
                                React.createElement(Icon, null, "chevron_left")),
                            React.createElement(ListItemText, { className: classNames('pl-0', classes.toolbarText), children: translate('choose-your-language') })),
                        React.createElement(MenuItem, { style: { background: tubeColor, color: 'white', fontWeight: 500 }, id: "lang-" + language, name: language, className: classes.listItem, key: language, onClick: this.onLangClick(language) },
                            React.createElement(ListItemText, { className: classNames('pl-0', classes.toolbarTextActive), children: translate(language) }),
                            React.createElement(Icon, { style: { color: 'white', marginLeft: 15 } }, "check_circle_outline")),
                        languagesToShow
                            .sort(function (a, b) { return translate(a).localeCompare(translate(b)); })
                            .map(function (lang) { return (React.createElement(MenuItem, { id: "lang-" + lang, name: lang, className: classes.listItem, key: lang, onClick: _this.onLangClick(lang) },
                            React.createElement(ListItemText, { className: classNames('pl-0', classes.toolbarText), children: translate(lang) }))); }),
                        !!organizationLanguages.length && (React.createElement(MenuItem, { className: classes.listItem, style: { borderTop: '1px solid #eee' }, onClick: function () { return _this.setState({ showAllLanguages: !_this.state.showAllLanguages }); } },
                            React.createElement(Icon, { style: { color: tubeColor } }, !showAllLanguages ? 'expand_more' : 'expand_less'),
                            React.createElement(ListItemText
                            // disableTypography={true}
                            , { 
                                // disableTypography={true}
                                className: classNames('pl-0', classes.toolbarText), primary: translate(showAllLanguages ? 'see-less' : 'see-all') }))))),
                    orgMenu && (React.createElement(React.Fragment, null,
                        React.createElement("div", { style: { minWidth: '305px' } },
                            React.createElement(MenuItem, { id: "hide-organization", name: "hide-organization", className: classes.listItem, onClick: this.orgMenuClose },
                                React.createElement(ListItemIcon, null,
                                    React.createElement(Icon, null, "chevron_left")),
                                React.createElement(ListItemText, { className: classNames('pl-0', classes.toolbarText), children: translate('organizations') })),
                            ((externalOrgsUserHasAccessTo && !!externalOrgsUserHasAccessTo.length) || originalOrgId) && (React.createElement("div", null,
                                originalOrgId ? (React.createElement(MenuItem, { onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0: return [4 /*yield*/, axios({
                                                        method: 'POST',
                                                        url: mainApiUrl.command + "/updateUserOrgSwitch",
                                                        headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
                                                        data: {
                                                            orgToSwitchTo: '',
                                                        },
                                                    })];
                                                case 1:
                                                    _a.sent();
                                                    this.userMenuClose();
                                                    localStorage.removeItem('collaborationOrgId');
                                                    window.location.href = '/home';
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); } },
                                    React.createElement(ListItemText, { className: classNames('pl-0', classes.toolbarText) }, "Back to original org"))) : (React.createElement("div", null)),
                                externalOrgsUserHasAccessTo
                                    .filter(function (item) { return item.id !== switchedOrgId; })
                                    .map(function (item) {
                                    return (React.createElement(MenuItem, { key: item.id, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0: return [4 /*yield*/, axios({
                                                            method: 'POST',
                                                            url: mainApiUrl.command + "/updateUserOrgSwitch",
                                                            headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
                                                            data: {
                                                                orgToSwitchTo: item.id,
                                                            },
                                                        })];
                                                    case 1: return [4 /*yield*/, _a.sent()];
                                                    case 2:
                                                        _a.sent();
                                                        this.userMenuClose();
                                                        localStorage.setItem('collaborationOrgId', item.id);
                                                        window.location.href = '/home';
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); } },
                                        React.createElement(ListItemIcon, null, item.logo ? (React.createElement("img", { width: 30, src: item.logo })) : (React.createElement(Avatar, { style: {
                                                backgroundColor: tubeColor,
                                                color: 'white',
                                            }, className: classes.channelImg }, getInitials(item.name)))),
                                        React.createElement(ListItemText, { className: classNames('pl-0', classes.toolbarText) }, item.name)));
                                }))))))),
                createLinkOpen && (React.createElement(CreateLinkDialog, { open: createLinkOpen, translate: translate, tubeColor: tubeColor, orgId: orgId, onClose: function () { return _this.setState({ createLinkOpen: false }); } })),
                isUserProfileDialogOpen && !originalOrgId && (React.createElement(Mutation, __assign({}, userCommandMutation()), function (userCommandReq) { return (React.createElement(UserProfileDialog, { translate: translate, tubeColor: tubeColor, saveUserProfile: function (data) {
                        return userCommandReq(userCommandVariables({
                            type: 'updateUserProfile',
                            payload: data,
                        }));
                    }, open: isUserProfileDialogOpen, onClose: function () { return _this.setState({ isUserProfileDialogOpen: false }); } })); })),
                isNewUserConfigurationDialogOpen && !originalOrgId && (React.createElement(Mutation, __assign({}, userCommandMutation()), function (userCommandReq) { return (React.createElement(UserInitialConfigurationDialog, { open: isNewUserConfigurationDialogOpen, tubeColor: tubeColor, orgId: orgId, profile: profile, userLanguage: _this.props.language, changeLang: _this.props.changeLang, userEmail: _this.props.email, saveUserProfile: function (data) {
                        return userCommandReq(userCommandVariables({
                            type: 'updateUserProfile',
                            payload: data,
                        }));
                    }, organizationLanguages: organizationLanguages, onClose: function () {
                        _this.setState({ isNewUserConfigurationDialogOpen: false });
                    } })); })),
                React.createElement(Mutation, __assign({}, addCreateLeadMutation()), function (createLeadReq) { return (React.createElement(React.Fragment, null, _this.state.isSupportDialogOpen && (React.createElement(SupportForm, { open: _this.state.isSupportDialogOpen, title: translate('support-form-title'), confirmLabel: translate('submit'), userEmail: _this.props.email, onClose: function (values) { return _this.onSupportFormSubmit(values, createLeadReq); } })))); }),
                React.createElement(SuccessDialog, { open: this.state.showSuccessForm, tubeColor: tubeColor, onClose: function () {
                        _this.setState({ showSuccessForm: false });
                    }, dialogContent: translate('support-success'), header: translate('success') }),
                React.createElement(ErrorDialog, { open: !!this.state.error, message: this.state.error, onClose: function () { return _this.setState({ error: null }); } })),
            isViewOnlyMode && (React.createElement("div", { className: "mr-16" },
                React.createElement(Button, { id: "login-button", className: " " + classes.loginButton, onClick: function () {
                        logout();
                    } }, translate('login'))))));
    };
    MainToolbar = __decorate([
        withStyles(styles, { withTheme: true })
    ], MainToolbar);
    return MainToolbar;
}(React.PureComponent));
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        logout: authActions.logoutUser,
        changeLang: changeLang,
        toggleSidebar: toggleSidebar,
        changeTooltipSettings: changeTooltipSettings,
        updateChannelList: updateChannelList,
    }, dispatch);
}
function mapStateToProps(state) {
    var auth = state.auth, ui = state.ui, translation = state.translation, channel = state.channel, sidebar = state.sidebar, searchVideos = state.searchVideos, notifications = state.notifications;
    return {
        user: auth.user,
        email: auth.user.email,
        profile: state.auth.user.profile,
        language: translation.lang,
        tubeColor: auth.tube.color,
        orgId: auth.organization.id,
        sidebarStatus: sidebar.status,
        isViewOnlyMode: ui.isViewOnlyMode,
        originalOrgId: state.auth.user.originalOrgId,
        switchedOrgId: state.auth.user.orgId,
        externalOrgsUserHasAccessTo: auth.user.externalOrgsUserHasAccessTo,
        userEmail: auth.user.data.email,
        channelId: channel.currentChannel,
        isLPUser: isLPUser(auth.user.email),
        searchValue: searchVideos.searchValue,
        translate: getTranslation(translation.lang),
        notifications: notifications.data || [],
        showUserEmail: isLPUser(auth.user.data.email),
        tooltipDisabled: auth.user.settings.tooltipDisabled,
        isConfigurationCompleted: auth.user.settings.isConfigurationCompleted,
        isNotificationsFeatureEnabled: isNotificationsFeatureEnabled(state),
        channelList: channel.channelList,
        isChannelLoaded: channel.isChannelLoaded,
        organizationLanguages: auth.organization.organizationLanguages,
        isUserProfileFeatureEnabled: isUserProfileFeatureEnabled(state),
    };
}
export default (function (props) {
    var Comp = compose(getTubeData(), listChannelsData('readChannel'), getUserAnalyticsData(), connect(mapStateToProps, mapDispatchToProps))(MainToolbar);
    return (React.createElement(Mutation, __assign({}, userCommandMutation()), function (userCommandReq) {
        return (React.createElement(Comp, __assign({}, props, { savePreferredLanguage: function (language) {
                return userCommandReq(userCommandVariables({
                    type: 'updatePreferredLanguage',
                    payload: { language: language },
                }));
            } })));
    }));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/layouts/Main/FullToolbar.tsx
// module id = 2025
// module chunks = 81